import { defineComponent as o, openBlock as a, createBlock as r, unref as l, mergeProps as d, withCtx as m, createElementVNode as p } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconTextAndImageInSquareFilled",
  __name: "IconTextAndImageInSquareFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const t = n;
    return (u, e) => (a(), r(l(i), d(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M18 3.25A2.75 2.75 0 0 1 20.75 6v12A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25h12M8 15.501a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8m0-3.5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8M7.75 7a.5.5 0 0 0-.5.5v2.001a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V7.5A.5.5 0 0 0 9.75 7h-2",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
